import React from 'react'

function Footer() {
  return (
    <>
      <div className="wfx-footer wow fadeInUp" data-wow-delay="0.1s">
        <div className="wfx-footer-container">
          <div className="wfx-footer-grid">
            <div className="wfx-footer-brand">
              <img src="./assets/img/logo/wfx-lab-white.png" className="top-main-logo" alt="WFX Labs" />
              <p className="wfx-footer-description">
                Digital products that convert.
                <br />
                Designed and engineered in Kandy & Dubai.
              </p>
              <div className="wfx-footer-socials">
                <a href="https://www.linkedin.com/company/wfx-labs" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                <a href="https://www.instagram.com/wfxlabs/" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="https://www.facebook.com/wfxlabs.io/" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="https://www.tiktok.com/@wfx.labs" aria-label="TikTok"><i className="fab fa-tiktok"></i></a>
              </div>
            </div>

            <div>
              <h6 className="wfx-footer-title">Services</h6>
              <ul className="wfx-footer-links">
                <li>Software development</li>
                <li>Web development</li>
                <li>Mobile apps</li>
                <li>SEO & growth</li>
                <li>Digital marketing</li>
                <li>Brand & UX</li>
              </ul>
            </div>

            <div>
              <h6 className="wfx-footer-title">Studio</h6>
              <ul className="wfx-footer-links">
                <li><a href="/our-works">Work</a></li>
                <li><a href="/about">Process</a></li>
                <li><a href="/about">Team</a></li>
                <li><a href="/contact-us">Careers</a></li>
                <li><a href="/contact-us">Contact</a></li>
              </ul>
            </div>

            <div>
              <h6 className="wfx-footer-title">Offices</h6>
              <div className="wfx-footer-office">
                <p className="wfx-footer-country">
                  <span>LK</span> Kandy
                </p>
                <p>No 02, Uyanwaththa Road, Polgolla, Kandy, Sri Lanka</p>
              </div>
              <div className="wfx-footer-office">
                <p className="wfx-footer-country">
                  <span>AE</span> Dubai
                </p>
                <p>43 A, Al Karama, Dubai, United Arab Emirates</p>
              </div>
            </div>
          </div>

          <div className="wfx-footer-bottom">
            <p>� 2026 WFX Labs (Pvt) Ltd. All rights reserved.</p>
            <div className="wfx-footer-bottom-links">
              <a href="/privacy">Privacy</a>
              <a href="/terms">Terms</a>
              <a href="/sitemap">Sitemap</a>
            </div>
          </div>
        </div>
      </div>

      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded back-to-top"><i className="bi bi-arrow-up"></i></a>
    </>
  )
}

export default Footer
